export const OfferStatusCssClasses = ["danger", "success", "warning", "info"];
export const OfferStatusTitles = ["Canceled", "Completed","on-hold", "Pending"];
export const OfferTypeCssClasses = ["success", "primary", ""];
export const OfferTypeTitles = ["Business", "Individual", ""];
export const defaultSorted = [{ dataField: "date", order: "desc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    network: "",
  },
  sortOrder: "desc", // asc||desc
  sortField: "date",
  pageNumber: 1,
  pageSize: 10
};
